<template>
  <div
    :class="{
      'group relative flex items-center justify-center gap-3 border border-www-color-neutral-medium md:h-10 md:border-x-0 md:border-www-color-neutral-very-light': true,
      'bg-[rgba(255,255,255,0.07)] text-www-color-white hover:text-www-color-primary-light md:bg-www-color-neutral-off-white md:text-www-color-neutral-medium-dark md:hover:text-www-color-primary-light': true,
      'cursor-pointer transition-colors duration-300': true,
      'rounded-s px-18px py-4 md:rounded-none': true,
    }"
  >
    <PtcIcon
      :class="{
        'text-xl text-www-color-primary-pale md:text-www-color-primary-light': true,
      }"
      name="ptc-lab"
    ></PtcIcon>
    <GeneralLink
      v-if="labsBarContent"
      v-bind="labsBarContent"
      :class="{
        'text-14px font-semibold [&_a]:after:absolute [&_a]:after:inset-0 [&_a]:after:content-[\'\']': true,
      }"
    ></GeneralLink>
    <span
      :class="{
        'before:block before:h-2px before:w-3 before:content-[\'\'] group-hover:before:w-6': true,
        'after:border-current after:-ml-2 after:block after:h-10px after:w-10px after:rotate-45 after:border-r-3px after:border-t-3px after:content-[\'\']': true,
        'flex items-center before:bg-www-color-primary-pale md:gap-1 md:before:bg-www-color-primary-light': true,
        'text-www-color-primary-pale before:transition-all before:duration-300 md:text-www-color-primary-light': true,
      }"
    ></span>
  </div>
</template>

<script setup lang="ts">
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import type { ProductDropdown } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';

defineProps<ProductDropdown['onshapeLabsBar']>();
</script>

<style scoped></style>
